export default "__VITE_ASSET__B0qfUhoc__"